/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { FilterOption } from 'bundles/enterprise-admin-drawers/components/types';
import ActivityFilterDateClause from 'bundles/enterprise-admin-user-filters/components/ActivityFilterDateClause';
import { EnrolledInCoursesAccordion } from 'bundles/enterprise-admin-user-filters/components/activity-filters/common/Accordions';
import { SubSection } from 'bundles/enterprise-admin-user-filters/components/ui';
import type { ActivityFilter } from 'bundles/enterprise-admin-user-filters/types';
import { Spacer } from 'bundles/enterprise-ui';

type Props = {
  selectedCourses: FilterOption[];
  activityFilter: ActivityFilter;
  onCoursesSelected: (selectedCourses: FilterOption[]) => void;
  onActivityFilterChange: (activityFilter: ActivityFilter) => void;
};

const EnrolledInACourseActivityFilter = ({
  selectedCourses,
  activityFilter,
  onCoursesSelected,
  onActivityFilterChange,
}: Props) => {
  return (
    <>
      <SubSection>
        <EnrolledInCoursesAccordion
          defaultExpanded
          selectedCourses={selectedCourses}
          onCoursesSelected={onCoursesSelected}
        />
      </SubSection>
      <Spacer size={16} />
      <SubSection>
        <ActivityFilterDateClause activityFilter={activityFilter} onActivityFilterChange={onActivityFilterChange} />
      </SubSection>
    </>
  );
};

export default EnrolledInACourseActivityFilter;
